import { createContext, useContext } from 'react';

export const LevelUpContextInitialState = {
  // flag to check if manager is viewing the levelUp or reportee is.
  isLoggedInEmployeeManager: false,
  isRoleSelectionModalOpen: false,
  levelUpDetails: null,

  levelUpProgressStatuses: [],

  // error states
  functionAndRoleNotSet: false,

  // for action items
  checkInInstanceId: null,
  checkInParentId: null,
  filterEmpIds: [],
  isTargetRoleSelected: true,

  levelUpTargetDates: [],
  competencyFilters: {
    BUILDING: false,
    EXCELLED: false,
    SKILLED: false,
    STARTING: false,
    NOT_CRITICAL: false,
  },
};

export const LevelUpContext = createContext({});

export const useLevelUpPageContext = () => useContext(LevelUpContext);
